import styled from "styled-components";

const StyledLoading = styled.div`
  width: 100%;
  padding: 100px;
  display: flex;
  justify-content: center;
`;
export default StyledLoading;
